import { createContext } from '@chakra-ui/react-utils';
import { SystemStyleObject } from '@chakra-ui/react-v2';

import type { EmptyPart } from './types';

export type EmptyStyles = Partial<Record<EmptyPart, SystemStyleObject>>;

const [EmptyStylesContextProvider, useEmptyStyles] = createContext<EmptyStyles>(
  {
    name: 'EmptyStylesContext',
    errorMessage:
      'useEmptyStyles: `context` is undefined. Seems you used an Empty sub-component that required a styles context outside of an Empty component.',
  },
);

export { EmptyStylesContextProvider, useEmptyStyles };
